import React from 'react';
import {IElementVideo} from '../../../../../incase-domain/elements/video';
import BaseVideoElementModal from './BaseVideoElementModal';

interface CreateVideoElementModalProps {
    isOpen?: boolean;
    onConfirm: (src: IElementVideo['videoSource']) => void;
    onClose: () => void;
}

function CreateVideoElementModal(props: CreateVideoElementModalProps): JSX.Element {
    const {isOpen, onConfirm, onClose} = props;

    return <BaseVideoElementModal isOpen={isOpen} onCancel={onClose} onConfirm={onConfirm} />;
}

export default CreateVideoElementModal;
